import './contact.css';
import { Footer } from "../../components/footer/Footer";
import { Header } from "../../components/header/Header";

export function Contact() {
    return (
        <>
            <div className='contact_app'>
                <Header />
                
                <Footer />
            </div>
        </>
    );
}